import LocalFireDepartmentOutlinedIcon from "@mui/icons-material/LocalFireDepartmentOutlined";
import WaterDropOutlinedIcon from "@mui/icons-material/WaterDropOutlined";
import ThunderstormOutlinedIcon from "@mui/icons-material/ThunderstormOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DirectionsCarOutlinedIcon from "@mui/icons-material/DirectionsCarOutlined";
import FlightOutlinedIcon from "@mui/icons-material/FlightOutlined";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";

export const CLAIM_FORM_ICON_MAP = {
  fire: LocalFireDepartmentOutlinedIcon,
  water: WaterDropOutlinedIcon,
  storm: ThunderstormOutlinedIcon,
  security: SecurityOutlinedIcon,
  home: HomeOutlinedIcon,
  car: DirectionsCarOutlinedIcon,
  flight: FlightOutlinedIcon,
  gavel: GavelOutlinedIcon,
  business: BusinessOutlinedIcon,
  category: CategoryOutlinedIcon,
};

export const getClaimFormIcon = (icon_key) =>
  CLAIM_FORM_ICON_MAP[icon_key] ?? CategoryOutlinedIcon;
